module.exports = __webpack_public_path__ + "static/media/bfile-snowmobile.215dcd94.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/bfile-snowmobile.svg
// module id = 557
// module chunks = 0